import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import { Alert, styled } from '@mui/material';
import { Typography, Switch } from '@mui/material';
import { Controller } from 'react-hook-form';
import { Disclosure } from 'further-ui/hooks';
import { useForm } from 'react-hook-form';
import Button from 'components/Button';
import { Column, Row } from 'components/Layout';

const StyledAlert = styled(Alert)`
  &.MuiAlert-root {
    background-color: transparent;
  }
  & .MuiAlert-message {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1;
  }
`;

type Props = {
  disclosure: Disclosure;
  onSubmit: (input: {
    notifySourceInvestor: boolean;
    notifyRecipientInvestor: boolean;
  }) => void;
  submitting: boolean;
};

const NotificationDialog: FC<Props> = ({
  disclosure,
  onSubmit,
  submitting,
}) => {
  const { control, setValue, ...form } = useForm({
    defaultValues: {
      notifySourceInvestor: true,
      notifyRecipientInvestor: true,
    },
  });

  return (
    <AlertDialog
      open={disclosure.isOpen}
      onClose={() => {
        disclosure.onClose();
        form.reset();
      }}
      title="Notify investors"
      content={
        <Column spacing="sm">
          <Typography variant="body1">
            Proceeding will send details of this transfer to the investors
            involved in the transfer.
          </Typography>
          <Typography variant="body1">
            If a transfer confirmation is sent to a new platform user, it will
            trigger an invitation to the portal for that user and will undisable
            that user's Further account.
          </Typography>
          <StyledAlert icon={false}>
            <Row spacing="xs">
              <Typography>Notify transferor</Typography>
              <Controller
                name="notifySourceInvestor"
                control={control}
                render={({ field: { name, value } }) => (
                  <Switch
                    name={name}
                    checked={!!value}
                    onChange={(event) => {
                      setValue('notifySourceInvestor', !!event.target.checked);
                    }}
                    data-testid={`switch-notify-source-investor`}
                  />
                )}
              />
            </Row>
            <Row spacing="xs">
              <Typography>Notify transferee</Typography>
              <Controller
                name="notifyRecipientInvestor"
                control={control}
                render={({ field: { name, value } }) => (
                  <Switch
                    name={name}
                    checked={!!value}
                    onChange={(event) => {
                      setValue(
                        'notifyRecipientInvestor',
                        !!event.target.checked,
                      );
                    }}
                    data-testid={`switch-notify-recipient-investor`}
                  />
                )}
              />
            </Row>
          </StyledAlert>
        </Column>
      }
      btnLabels={{
        cancel: 'Go back',
        confirm: 'Submit',
      }}
      confirmBtnComponent={
        <Button
          variant="contained"
          color="primary"
          disabled={submitting}
          loading={submitting}
          type="button"
          name="proceed"
          onClick={() => {
            disclosure.onClose();
            onSubmit(form.getValues());
          }}
        >
          Submit
        </Button>
      }
    />
  );
};

export default NotificationDialog;
